import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from './utils/pwaInstall';
import './index.css';

registerServiceWorker();

/** Error boundary mínimo: evita white screen si un chunk/import falla por caché stale. */
class AppErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    // Si el error es por módulo no encontrado (asset viejo), forzar recarga limpia.
    const msg = error instanceof Error ? error.message : String(error);
    if (
      msg.includes("Failed to fetch dynamically imported module") ||
      msg.includes("Loading chunk") ||
      msg.includes("Loading CSS chunk")
    ) {
      window.location.reload();
      return;
    }
    console.error("[AppErrorBoundary]", error);
  }

  render() {
    if (this.state.hasError) {
      return React.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column" as const,
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            fontFamily: "system-ui, sans-serif",
            color: "#e2e8f0",
            backgroundColor: "#020305",
            gap: "1rem",
            padding: "1rem",
            textAlign: "center" as const,
          },
        },
        React.createElement("p", null, "Ocurrió un error al cargar la aplicación."),
        React.createElement(
          "button",
          {
            onClick: () => window.location.reload(),
            style: {
              padding: "0.5rem 1.5rem",
              borderRadius: "0.375rem",
              border: "1px solid #334155",
              backgroundColor: "#1e293b",
              color: "#e2e8f0",
              cursor: "pointer",
              fontSize: "0.875rem",
            },
          },
          "Recargar"
        )
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
